// Counts live (created - revoked) Blob URLs to help diagnose handle leaks on
// long-running kiosk sessions. The patches preserve original `URL.create/revokeObjectURL`
// semantics — counter updates are wrapped in try/catch so telemetry can never
// break the URL APIs themselves.

let installed = false;
let liveBlobUrls = 0;

export function getLiveBlobUrlCount(): number | undefined {
  try {
    return liveBlobUrls;
  } catch {
    return undefined;
  }
}

export function installBlobUrlTelemetry(): void {
  if (installed) {
    return;
  }

  try {
    if (
      typeof URL === "undefined" ||
      typeof URL.createObjectURL !== "function" ||
      typeof URL.revokeObjectURL !== "function"
    ) {
      return;
    }

    const originalCreate = URL.createObjectURL.bind(URL);
    const originalRevoke = URL.revokeObjectURL.bind(URL);

    URL.createObjectURL = function patchedCreateObjectURL(
      blob: Blob | MediaSource
    ) {
      const url = originalCreate(blob);
      try {
        liveBlobUrls += 1;
      } catch {
        // never break createObjectURL
      }
      return url;
    };

    URL.revokeObjectURL = function patchedRevokeObjectURL(url: string) {
      try {
        liveBlobUrls = Math.max(0, liveBlobUrls - 1);
      } catch {
        // never break revokeObjectURL
      }
      return originalRevoke(url);
    };

    installed = true;
  } catch {
    // never break app startup
  }
}
